<li class="attachment-item">
    <mat-icon class="text-black" class="attachment-item-edit" (click)="editAttachment()">edit</mat-icon>
  <a class="attachment-name" [href]="attachment.Url" target="new">
      <img [src]="imagePath"/>&nbsp;
      <span class="attachment-info-name">{{attachment.Title}}</span>
    </a>
</li>
